@if (listing().village) {
  <div
    class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm text-primary-500 px-4 py-5 sm:px-6 sm:py-6"
  >
    <app-listing-details-accordion
      accordionId="village-details"
      [title]="listing().village.displayTitle!"
    >
      <div
        id="content"
        class="mt-4 [&>a]:text-blue-500 [&>a]:underline"
        [innerHTML]="listing().village.description ?? listing().village.displayTitle"
      ></div>
    </app-listing-details-accordion>
  </div>
}
